import React from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "store/index";
import { handleUpdateFieldsConfig } from "store/payments/methods/slice";
import SwitchBtn from "components/buttons/SwitchBtn";
import InnerInput from "components/inputs/InnerInput/InnerInput";

interface Props {
  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  setFieldError: (field: string, code: string) => void;
  isReadOnly: boolean;
}

const MethodsAutoWithdrawalTab: React.FC<Props> = ({
  fieldErrors,
  clearFieldError,
  setFieldError,
  isReadOnly,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const config = useAppSelector((store) => store["payment-methods"].config);
  const params = config?.config ?? {};
  const enabled = params.autoWithdrawalEnabled === true;
  const effectiveCurrency =
    typeof params.autoWithdrawalThresholdCurrency === "string"
      ? params.autoWithdrawalThresholdCurrency
      : "";

  const updateParams = (fields: Record<string, unknown>) => {
    if (!config) return;
    dispatch(
      handleUpdateFieldsConfig({
        config: { ...params, ...fields },
      }),
    );
  };

  return (
    <>
      <div className="bonus-form-custom-row payment-config-auto-withdrawal-toggle">
        <SwitchBtn
          activeTxt={t("autoWithdrawalEnabled")}
          isActive={enabled}
          handleClick={() => {
            const threshold = String(
              params.autoWithdrawalThreshold ?? "",
            ).trim();
            if (
              enabled &&
              threshold !== "" &&
              !/^\d+(\.\d+)?$/.test(threshold)
            ) {
              setFieldError(
                "config.autoWithdrawalThreshold",
                "InvalidValue",
              );
              return;
            }
            updateParams({ autoWithdrawalEnabled: !enabled });
            clearFieldError("config.autoWithdrawalEnabled");
          }}
          hasError={Boolean(fieldErrors?.["config.autoWithdrawalEnabled"])}
          disabled={isReadOnly}
        />
      </div>

      <div className="bonus-form-content payment-config-auto-withdrawal-threshold">
        <div className="bonus-form-box">
          <div className="bonus-form-box--item">
            <InnerInput
              value={String(params.autoWithdrawalThreshold ?? "")}
              placeholder={t("autoWithdrawalThreshold")}
              label={t("autoWithdrawalThreshold")}
              tooltipText={t("autoWithdrawalThresholdTooltip")}
              tooltipPosition="top-left"
              type="text"
              inputMode="decimal"
              suffix={effectiveCurrency}
              id="payment-config-autoWithdrawalThreshold"
              onChange={(value) => {
                updateParams({
                  autoWithdrawalThreshold: value,
                });
                clearFieldError("config.autoWithdrawalThreshold");
              }}
              hasError={Boolean(
                fieldErrors?.["config.autoWithdrawalThreshold"],
              )}
              disabled={isReadOnly || !enabled}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MethodsAutoWithdrawalTab;
